import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';
import { injectTellentNavigationScope } from '@core/tellent-types';

import { TellentCurrentUserEntityActions } from '../current-user';
import { TellentNavigationHttpClient } from './http';
import { TellentNavigationActions } from './store';

@Injectable({ providedIn: 'root' })
export class TellentNavigationEffects {
  #actions = inject(Actions);
  #effects = createEffectFactory(TellentNavigationActions, this.#actions);
  #svc = inject(TellentNavigationHttpClient);
  #scope = injectTellentNavigationScope();

  // TODO: handle errors
  public fetchMainNav$ = this.#effects(TellentNavigationActions.fetchMainNav, ({ payload }) =>
    this.#svc
      .fetchMainNav(payload.navScope)
      .pipe(map(data => TellentNavigationActions.fetchMainNavSuccess({ payload: { data } }))),
  );

  // TODO: handle errors
  public fetchSettingsNav$ = this.#effects(
    TellentNavigationActions.fetchSettingsNav,
    ({ payload }) =>
      this.#svc.fetchSettingsNav(payload.navScope).pipe(
        map(data =>
          TellentNavigationActions.fetchSettingsNavSuccess({
            payload: { data },
          }),
        ),
      ),
  );

  public refreshOnProfileUpdate = createEffect(() =>
    this.#actions.pipe(
      ofType(TellentCurrentUserEntityActions.updateCurrentUserDataSuccess),
      map(() =>
        TellentNavigationActions.fetchMainNav({
          payload: {
            navScope: this.#scope,
          },
        }),
      ),
    ),
  );
}
